import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {Settings} from '@orga-app/settings/settings.model';
import {select, Store} from '@ngrx/store';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import * as actionsUi from './vorlage-auswaehlen.actions.ui';

import * as fromCurrentPage from './vorlage-auswaehlen.selectors';
import {SafeUrl} from '@angular/platform-browser';
import {IncidentVorlageDetail} from '../../../../clients/incidents';
import {PageState} from './vorlage-auswaehlen.reducer';
import {ModalController} from '@ionic/angular';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';

@Component({
    selector: 'app-veranstaltung-auswaehlen',
    templateUrl: './vorlage-auswaehlen.page.html',
})
export class VorlageAuswaehlenPage implements OnInit {
    @ViewChild('logoImagePlaceholder', {static: false}) logoImagePlaceholder: ElementRef;
    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    private aiName = 'VeranstaltungWaehlenPage';
    public vorlagenList$: Observable<Array<ListInputItem>>;
    public vorlagenLaden$: Observable<boolean>;
    public vorlagenFehler$: Observable<boolean>;


    constructor(
        private store: Store<PageState>,
        private settingsProvider: SettingsProvider,
        private modalCtrl: ModalController) {

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();
    }


    ngOnInit() {
        this.vorlagenList$ = this.store.pipe(select(fromCurrentPage.getVorlagenSopiList));
        this.vorlagenLaden$ = this.store.pipe(select(fromCurrentPage.getVorlagenLaden));
        this.vorlagenFehler$ = this.store.pipe(select(fromCurrentPage.getVorlagenFehler));
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        await this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    async verlasseModal() {
        await this.modalCtrl.dismiss();
    }

    async selectVorlage(vorlage: IncidentVorlageDetail) {
        await this.modalCtrl.dismiss({
            selectedVorlageId: vorlage.incident_vorlage_id,
            selectedVorlage: vorlage
        });
    }

    async refreshData() {
        await this.store.dispatch(new actionsUi.RefreshDataAction());
    }
}
